import { GlobalAxios } from "../axios/axios-config";
import { ITicketAutomationReceivedRuleEstablishment } from "../models/ticket-automation-received-rule-establishment";

// Rota principal da regra de automação com estabelecimentos (Igual ao seu CURL)
const TICKET_AUTOMATION_RECEIVED_RULE_ESTABLISHMENT_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRuleEstablishment/";

// Rota para buscar a lista global de todos os estabelecimentos cadastrados no sistema
// (Ajuste o final dela caso seu back-end use outro nome, ex: /api/v1/Establishment)
const ESTABLISHMENT_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/Establishment";

// 1. CREATE (POST) - Envia os dados para salvar
export const createTicketAutomationReceivedRuleEstablishment = (
  item: ITicketAutomationReceivedRuleEstablishment,
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULE_ESTABLISHMENT_ROUTE,
    item,
  );
};

// 2. READ (GET por ID) - Busca os dados de um vínculo específico para abrir na edição
export const getTicketAutomationReceivedRuleEstablishmentById = (
  id: string,
) => {
  return GlobalAxios.get<ITicketAutomationReceivedRuleEstablishment>(
    TICKET_AUTOMATION_RECEIVED_RULE_ESTABLISHMENT_ROUTE + id,
  );
};

// 3. UPDATE (PUT) - Atualiza os dados do vínculo baseado no ID
export const updateTicketAutomationReceivedRuleEstablishmentById = ({
  item,
  id,
}: {
  item: ITicketAutomationReceivedRuleEstablishment;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULE_ESTABLISHMENT_ROUTE + id,
    item,
  );
};

export type TEstablishmentListItem = {
  id: string;
  name: string;
  code: string | null;
};

export const getAllEstablishmentsList = () => {
  return GlobalAxios.get<TEstablishmentListItem[]>(
    `${ESTABLISHMENT_ROUTE}/ByCompanyGroup/list`,
  );
};
